module.exports = __webpack_public_path__ + "img/C03TechBowmanMaster_ua.ad2c9981.webp";